/**
 * Read documentation here: https://panter.github.io/vue-i18next/guide/started.html#requirements
 *
 */
import Vue from 'vue';
import i18next from 'i18next';
import VueI18Next from '@panter/vue-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
//import HttpApi from 'i18next-http-backend';

import loadResources from './loadResources';

const debug = false; //= process.env.NODE_ENV !== 'production';

Vue.use(VueI18Next);

var supportedLanguages = [
  { code: 'en', name: 'English', flag: 'img/flags/en.png' },
  { code: 'es', name: 'Español', flag: 'img/flags/es.png' },
  { code: 'pt', name: 'Português', flag: 'img/flags/pt.png' },
  { code: 'hi', name: 'हिन्दी', flag: 'img/flags/in.png' },
  { code: 'fr', name: 'Français', flag: 'img/flags/fr.png' },
  { code: 'ja', name: '日本語', flag: 'img/flags/jp.png' },
  { code: 'it', name: 'Italiano', flag: 'img/flags/it.png' },
  { code: 'ar', name: "العربية", flag: 'img/flags/sa.png' },
  { code: 'id', name: 'Indonesia', flag: 'img/flags/id.png' },
  { code: 'zh', name: '中文', flag: 'img/flags/cn.png' },
  { code: 'de', name: 'Deutsche', flag: 'img/flags/de.png' },
  { code: 'pl', name: 'Polskie', flag: 'img/flags/pl.png' },
  { code: 'ru', name: 'русский', flag: 'img/flags/ru.png' },
  { code: 'tr', name: 'Türk', flag: 'img/flags/tr.png' },
  { code: 'uk', name: 'Український', flag: 'img/flags/ua.png' },
  { code: 'vi', name: 'Tiếng Việt', flag: 'img/flags/vi.png' },
];

i18next.use(LanguageDetector).init({
  fallbackNS: ['main'],
  defaultNS: 'main',
  keySeparator: false,
  fallbackLng: 'en',
  lng: localStorage.getItem('site_locale') || 'en',
  debug: debug,
  resources: loadResources(),
  supportedLanguages, // not sure if this is a good idea, but we make our language list available to all of vue via vm.$i18n.i18next.supportedLanguages
  /*backend: {
      // load from backend http proxy
      loadPath: 'locales/{{lng}}/{{ns}}.json',
      //crossDomain: true
    },*/
});

export default new VueI18Next(i18next);
